import { useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.log(
      "Redirecting from non-existent route to Discover:",
      location.pathname
    );
  }, [location.pathname]);

  return <Navigate to="/discover" replace />;
};

export default NotFound;
